import { PropsWithChildren } from 'react';

import { FormErrorFocus } from 'components';
import { Form, FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { DeepPartial } from 'types/deepPartial';

import { OrderFormType, FormErrors, getSchema } from '../../forms/orderForm';
import { useOrderContext } from '../../providers/OrderProvider';

export interface OrderFormProps {
  onSubmit: FormSubmit<OrderFormType>;
  initialValues?: DeepPartial<OrderFormType>;
  formError?: FormErrors;
}

export const OrderForm = ({
  initialValues,
  formError,
  children,
  onSubmit,
}: PropsWithChildren<OrderFormProps>) => {
  const { t } = useTranslation();

  const { orderType, disabledDates, minEndDate } = useOrderContext();

  return (
    <Form
      hidePlaceholderIfReadonly
      initialReadOnly
      initialErrors={formError}
      initialValues={initialValues}
      validationSchema={getSchema(t, {
        orderType,
        minEndDate,
        disabledDates,
      })}
      onSubmit={onSubmit}
    >
      <FormErrorFocus />
      {children}
    </Form>
  );
};
